// src/modules/inventory/pages/InventoryEditPage.tsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import InventoryForm from "../components/InventoryForm";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import api from "../../../services/api";

const InventoryEditPage: React.FC = () => {
  useProtectedRoute();
  const { token } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState<any>(null);

  useEffect(() => {
    if (!id) return;
    (async () => {
      try {
        const res = await api.get(`/inventory/${id}`, { headers: { Authorization: `Bearer ${token}` } });
        setItem(res.data);
      } catch (e: any) {
        alert(e?.response?.data?.message || "Failed to load item.");
        navigate("/inventory");
      }
    })();
  }, [id, token, navigate]);

  const handleSubmit = async (data: any) => {
    try {
      await api.put(`/inventory/${id}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate("/inventory");
    } catch (err: any) {
      alert(err.response?.data?.message || "Could not update item.");
    }
  };

  if (!item) return <div className="text-center py-12">Loading...</div>;

  return (
    <div className="max-w-4xl mx-auto p-4 md:p-8">
      <h1 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800">Edit Inventory Item</h1>
      <InventoryForm initialData={item} onSubmit={handleSubmit} />
    </div>
  );
};

export default InventoryEditPage;
